import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import qs from 'query-string';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import TransparentButton from '../../modules/TransparentButton';
import Overlay from '../../modules/Overlay';
import Button from "../../modules/Button";
import InlineButtonPanel from "../../modules/InlineButtonPanel";

import * as serviceActions from '../../../actions/services';
import * as licenceActions from '../../../actions/licences';

import licenceKeyNames from '../../../services/ui/licenceKeyNames';
import notifier from '../../../services/ui/notifier';

import { toggleVisibility } from '../../../services/ui/visibilityToggler';

import styles from './styles.scss';
import classnames from "classnames/bind";

function getLicenceTypeClassNames(assignedLicence) {

    const cx = classnames.bind(styles);

    return cx({
        'licence-type': true,
        'licence-type--unassigned': !assignedLicence
    });
}

function getAssignedLicenceClassNames(serviceLicence, licence) {

    const cx = classnames.bind(styles);

    return cx({
        'assign-menu__item': true,
        'assign-menu__item--active': serviceLicence && serviceLicence['licence_id'] === licence.id
    });
}

const LicenceDetails = props => {

    const { service, licenceName, licenceKey, viewUrl, serviceLicence } = props;

    return (
        <div className={styles['licence-details']}>
            <span className={getLicenceTypeClassNames(serviceLicence)}>
                { licenceName }
            </span>

            <div className={styles['action-panel']}>

                <div className={styles['assign-action-container']}>
                    <a
                        href=""
                        onClick={props.onMenuAssignmentToggle.bind(this, `${service.id}_${licenceKey}`)}
                        className={styles['assign-action']}>
                        Assign
                    </a>

                    {props.expandedAssignmentMenu === `${service.id}_${licenceKey}` &&
                        <ul className={styles['assign-menu']}>

                            <li>
                                <Link
                                    to={`/admin/new-licence?assignService=${service.id}&licenceTypeKey=${licenceKey}`}
                                    className={styles['assign-menu__item']}
                                >
                                    New Licence
                                </Link>
                            </li>

                            {props.licences.map(licence => {
                                return (
                                    <li key={licence.id}>
                                        <span
                                            onClick={props.onLicenceAssign.bind(this, service.id, licence.id, licenceKey)}
                                            className={getAssignedLicenceClassNames(serviceLicence, licence)}
                                        >
                                            { licence.name }
                                        </span>
                                    </li>
                                )
                            })}
                        </ul>
                    }
                </div>

                {serviceLicence &&
                    <Link className={styles['view-action']} to={viewUrl}>View</Link>
                }

                {serviceLicence &&
                    <Link className={styles['view-action']} to={`/admin/edit-licence/${serviceLicence.licence_id}`}>Edit</Link>
                }

                {serviceLicence &&
                    <a
                        href=""
                        onClick={props.onRemoveLicenceClick.bind(this, service, serviceLicence, licenceKey)}
                        className={styles['remove-action']}>
                        Remove
                    </a>
                }
            </div>
        </div>
    )
};

class AdminServiceLicences extends React.Component {

    constructor() {
        super();

        this.state = {
            expandedServicePanels: [],
            expandedAssignmentMenu: null,
            isRemovingLicence: false,
            licenceRemovalOpts: null
        };
    }

    componentDidMount() {

        this.props.refreshServices();
        this.props.refreshLicences();

        const { serviceId } = qs.parse(this.props.location.search);

        if (serviceId) {
            this.setState({ expandedServicePanels: [parseInt(serviceId)] });
        }
    }

    _toggleServiceExpansion(serviceId) {

        this.setState({
            expandedServicePanels: toggleVisibility(this.state.expandedServicePanels, serviceId)
        });
    }

    _toggleAssignmentMenu(serviceLicenceKey, event) {

        event.preventDefault();

        this.setState({
            expandedAssignmentMenu: this.state.expandedAssignmentMenu === serviceLicenceKey ? null : serviceLicenceKey
        });
    }

    _getServiceContainerClassNames(serviceId) {

        const cx = classnames.bind(styles);

        return cx({
            'service-container': true,
            'service-container--expanded': this.state.expandedServicePanels.includes(serviceId)
        });
    }

    _getLicenceListClassNames(serviceId) {

        const cx = classnames.bind(styles);

        return cx({
            'licence-list': true,
            'licence-list--expanded': this.state.expandedServicePanels.includes(serviceId)
        });
    }

    _assignLicence(serviceId, licenceId, licenceType, event) {

        this._toggleAssignmentMenu(serviceId, event);

        this.props.assignLicence(serviceId, licenceId, licenceType)
            .then(() => {
                notifier.addNotification({
                    'level': 'success',
                    'message': 'The licence was assigned successfully.'
                });
            });
    }

    _showRemoveLicenceOverlay(service, serviceLicence, licenceKey, event) {

        event.preventDefault();

        this.setState({
            licenceRemovalOpts: {
                serviceLicenceId: serviceLicence.id,
                serviceName: service.name,
                licenceName: licenceKeyNames[licenceKey]
            }
        });
    }

    _removeLicenceType() {

        this.setState({ isRemovingLicence: true });

        this.props.removeLicence(this.state.licenceRemovalOpts['serviceLicenceId'])
            .then(() => {
                this.setState({ isRemovingLicence: false });
                this._hideRemoveLicenceOverlay();
            });
    }

    _hideRemoveLicenceOverlay() {
        this.setState({
            licenceRemovalOpts: null
        });
    }

    render() {

        return (
            <Page>
                <PageMeta title="Licence Administration" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    <PageSection>

                        <Link className={styles['manage-licences']} to="/admin/manage-licences">Manage Licences</Link>

                        {this.props.services.map(service => {
                            return (
                                <div key={service.id} className={this._getServiceContainerClassNames(service.id)}>

                                    <TransparentButton onClick={this._toggleServiceExpansion.bind(this, service.id)} className={styles['service-button']}>
                                        <h2 className={styles['service-name']}>{ service.name }</h2>
                                    </TransparentButton>

                                    <div className={this._getLicenceListClassNames(service.id)}>

                                        <ul>
                                            <li>
                                                <LicenceDetails
                                                    service={service}
                                                    viewUrl={`/services/${service.id}/licences/tos`}
                                                    licenceKey="terms_of_service"
                                                    licenceName="Terms of Service"
                                                    serviceLicence={service['terms_of_service_licence']}
                                                    licences={this.props.licences}
                                                    expandedAssignmentMenu={this.state.expandedAssignmentMenu}
                                                    onMenuAssignmentToggle={this._toggleAssignmentMenu.bind(this)}
                                                    onLicenceAssign={this._assignLicence.bind(this)}
                                                    onRemoveLicenceClick={this._showRemoveLicenceOverlay.bind(this)}
                                                />
                                            </li>

                                            <li>
                                                <LicenceDetails
                                                    service={service}
                                                    viewUrl={`/services/${service.id}/licences/client`}
                                                    licenceKey="client"
                                                    licenceName="Client Licence"
                                                    serviceLicence={service['client_licence']}
                                                    licences={this.props.licences}
                                                    expandedAssignmentMenu={this.state.expandedAssignmentMenu}
                                                    onMenuAssignmentToggle={this._toggleAssignmentMenu.bind(this)}
                                                    onLicenceAssign={this._assignLicence.bind(this)}
                                                    onRemoveLicenceClick={this._showRemoveLicenceOverlay.bind(this)}
                                                />
                                            </li>

                                            <li>
                                                <LicenceDetails
                                                    service={service}
                                                    viewUrl={`/services/${service.id}/licences/eula`}
                                                    licenceKey="eula"
                                                    licenceName="EULA"
                                                    serviceLicence={service['eula_licence']}
                                                    licences={this.props.licences}
                                                    expandedAssignmentMenu={this.state.expandedAssignmentMenu}
                                                    onMenuAssignmentToggle={this._toggleAssignmentMenu.bind(this)}
                                                    onLicenceAssign={this._assignLicence.bind(this)}
                                                    onRemoveLicenceClick={this._showRemoveLicenceOverlay.bind(this)}
                                                />
                                            </li>

                                            <li>
                                                <LicenceDetails
                                                    service={service}
                                                    viewUrl={`/services/${service.id}/licences/contributions`}
                                                    licenceKey="contributions"
                                                    licenceName="Contribution Rules"
                                                    serviceLicence={service['contributions_licence']}
                                                    licences={this.props.licences}
                                                    expandedAssignmentMenu={this.state.expandedAssignmentMenu}
                                                    onMenuAssignmentToggle={this._toggleAssignmentMenu.bind(this)}
                                                    onLicenceAssign={this._assignLicence.bind(this)}
                                                    onRemoveLicenceClick={this._showRemoveLicenceOverlay.bind(this)}
                                                />
                                            </li>

                                            <li>
                                                <LicenceDetails
                                                    service={service}
                                                    viewUrl={`/services/${service.id}/licences/reasonable-use`}
                                                    licenceKey="reasonable_use"
                                                    licenceName="Reasonable Use"
                                                    serviceLicence={service['reasonable_use_licence']}
                                                    licences={this.props.licences}
                                                    expandedAssignmentMenu={this.state.expandedAssignmentMenu}
                                                    onMenuAssignmentToggle={this._toggleAssignmentMenu.bind(this)}
                                                    onLicenceAssign={this._assignLicence.bind(this)}
                                                    onRemoveLicenceClick={this._showRemoveLicenceOverlay.bind(this)}
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )
                        })}

                    </PageSection>

                </ContentColumn>

                {this.state.licenceRemovalOpts &&
                    <Overlay isOpen={true}>
                        <p>
                            Are you sure you want to remove the <strong>{ this.state.licenceRemovalOpts.licenceName }</strong> licence from <strong>{ this.state.licenceRemovalOpts.serviceName }</strong>?
                        </p>

                        <InlineButtonPanel>
                            <Button disabled={this.state.isRemovingLicence} onClick={this._removeLicenceType.bind(this)}>Yes</Button>
                            <Button onClick={this._hideRemoveLicenceOverlay.bind(this)}>No</Button>
                        </InlineButtonPanel>
                    </Overlay>
                }

            </Page>
        )
    }
}

const mapStateToProps = state => {
    return {
        services: state.services.services,
        licences: state.licences.licences
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeLicence(serviceLicenceId) {
            return dispatch(serviceActions.removeLicence(serviceLicenceId));
        },
        assignLicence(serviceId, licenceId, licenceType) {
            return dispatch(serviceActions.assignLicence(serviceId, licenceId, licenceType));
        },
        refreshLicences() {
            dispatch(licenceActions.refreshAllLicences());
        },
        refreshServices() {
            dispatch(serviceActions.refreshAllServices());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminServiceLicences);